<div class="elementCont mrgl-5 mrgr-5" id="userinfocont-{{ indexofelement }}">
    <div >
     
  
      <div class="mrgt-5">
        <label #userInfoheadingLabel id="userInfoheadingLabel-{{ indexofelement }}" class="txt-bold user_info_heading"></label>

        <div class="flex d-flex-custom-form d-flex-custom-form-768 user_info_textbox">
            <div class="w-100-custom-form">
            <!--class="form-group form-group-custom-for-element w-100-custom-form-768 ">-->
                <div class="overflowWrapAnywhere">
                    <label for="" #userInfonameLabel class="inpLabel" id="userInfonameLabel">Name<span style='color:red'>*</span></label>
                  </div>
              
                  <div class="mrgt-5">
                    <input
                      type="text"
                      #userInfonameInp
                      placeholder="Name"
                      id="userInfonameInp-{{ indexofelement }}"
                      (keydown)="keydown($event, indexofelement)"
                      class="form-control form-control-custom-for-element inpText inpBox"
                    />
                  </div>
                  <div
                    class="error-msg overflowWrapAnywhere"
                    id="nameerror-{{ indexofelement }}"
                    #nameError
                   ></div>
            </div>
            <div class="w-100-custom-form mrgl-10-above768 ">
              <!--class="form-group form-group-custom-for-element w-100-custom-form-768 ">-->
                  <div class="overflowWrapAnywhere">
                    <label for="" #userInfoemailLabel class="inpLabel" id="userInfoemailLabel">Email<span style='color:red'>*</span></label>
                  </div>
              
                  <div class="mrgt-5">
                    <input
                      type="text"
                      #userInfoemailInp
                      placeholder="Email"
                      id="userInfoemailInp-{{ indexofelement }}"
                      (keydown)="keydown($event, indexofelement)"
                      class="form-control form-control-custom-for-element inpText inpBox"
                    />
                  </div>
                  <div
                  class="error-msg overflowWrapAnywhere"
                  id="emailerror-{{ indexofelement }}"
                  #emailerror
                 ></div>
            </div>
            <div class="w-100-custom-form mrgl-10-above768">
              <!--class="form-group form-group-custom-for-element w-100-custom-form-768 ">-->
                  <div class="overflowWrapAnywhere">
                    <label for="" #userInfophoneLabel class="inpLabel" id="userInfophoneLabel">Phone<span style='color:red'>*</span></label>
                  </div>
              
                  <div class="mrgt-5">
                    <input
                      type="text"
                      #userInfophoneInp
                      placeholder="Phone"
                      id="userInfophoneInp-{{ indexofelement }}"
                      (keydown)="keydown($event, indexofelement)"
                      class="form-control form-control-custom-for-element inpText inpBox"
                    />
                  </div>
                  <div
                  class="error-msg overflowWrapAnywhere"
                  id="phoneerror-{{ indexofelement }}"
                  #phoneerror
                 ></div>
            </div>
        </div>

      </div>
    </div>
  </div>
 
  